import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, HasId, Page, Report, ReportArchive } from '../../model';
import { buildQuery } from '../../util';
import { Params } from '@angular/router';

interface ArticleEvaluation {
  summary?: string;
  articleId: string;
  rating?: 'SPECIFIED' | 'MITIGATED' | 'NONE';
  id: string;
  noteDocuments: HasId[];
}

@Injectable({ providedIn: 'root' })
export class ReportService extends _Service<Report> {
  constructor() {
    super('api/report');
  }

  downloadPreviewPdf = async (report: HasId) => this.http.getBlob(`api/report/${report.id}/download-preview`);
  createArchive = async (report: HasId) => this.http.post<ReportArchive>(`api/report/${report.id}/create-archive`, {});
  downloadArchiveZip = async (archive: HasId) => this.http.getBlob(`api/report-archive/${archive.id}/download-zip`);
  downloadArchivePdf = async (archive: HasId) => this.http.getBlob(`api/report-archive/${archive.id}/download-pdf`);
  detailArchive = async (archiveId: AppId) => this.http.get<ReportArchive>(`api/report-archive/${archiveId}`);
  updateArchive = async (
    archiveId: AppId,
    updates: { startDate?: string | null; endDate?: string | null; articleNumbers?: string[] }
  ) => this.http.put<ReportArchive>(`api/report-archive/${archiveId}`, updates);
  confirmChanges = async (report: Report, products: AppId[], documents: AppId[], removedDocuments: AppId[] = []) =>
    this.http.post(`api/report/${report.id}/confirm`, { products, documents, removedDocuments });
  updateProduct = async (report: AppId, product: AppId, articles: ArticleEvaluation[]) =>
    this.http.put(`api/report/${report}/chain/${product}`, articles);
  searchReportsByArticles = async (queryParams: Params, siteId: string, articleNumbers?: string[], date?: string) =>
    this.http.post<{ missingArticleNumbers: [] } & Page<ReportArchive>>(
      `api/site/${siteId}/archive/search-by-articles` + buildQuery(queryParams),
      { articleNumbers, date }
    );
  searchReportsByIds = async (siteId: string, reportIds: string[]) =>
    this.http.post<ReportArchive[]>(`api/site/${siteId}/archive/search-by-ids`, reportIds);
}
